import { ATTENTE_REPONSE, AUCUN } from '@/configuration/optionBlocage/optionBlocage';
import * as devisConf from '@/configuration/devisConf';

function getTotalHtAvecLigneRemise(ligne) {
  let totalHt = 0;
  ligne.lignesCommande.filter(l => l.typeProduit === devisConf.LOCATION).forEach((ligneEnfant) => {
    totalHt += ligneEnfant.totalHtAvecLigneRemise;
  });
  return totalHt;
}

function getTotalHtParFace(ligne, qteFacesSouhaites) {
  if (qteFacesSouhaites === 0) return 0;
  const totalHt = getTotalHtAvecLigneRemise(ligne);
  return totalHt / qteFacesSouhaites;
}

function genererDemande(ligne, devis, avertissement) {
  const ligneCommande = devis.lignesCommande.find((devisLigne) => {
    return devisLigne.id === ligne.id;
  });
  return {
    selected: false,
    ligneId: ligne.id,
    libelleProduit: ligne.produit.libelle,
    devisId: devis.id,
    anneeSemaine: ligne.ligneReseau.anneeSemaine,
    qteFacesSouhaitees: ligne.ligneReseau.qteFacesSouhaitees,
    qteFacesPrevues: ligne.ligneReseau.qteFacesPrevues,
    totalHtAvecLigneRemise: getTotalHtAvecLigneRemise(ligneCommande),
    totalNetParFace: getTotalHtParFace(ligneCommande, ligne.ligneReseau.qteFacesSouhaitees),
    etatSouhaite: ligne.etatSouhaite,
    etatObtenu: ligne.etatObtenu,
    rangOption: ligneCommande.rangOption,
    etatObtenuReponse: avertissement ? avertissement.etatObtenuReponse : ATTENTE_REPONSE,
    produitId: ligne.produit.id,
    avertissement: !!avertissement,
    ligneCommande: ligneCommande,
    societeId: devis.societeId,
  };
}

export default function getTabDemandesTempo(lignes, listeDevis, lignesAvertissement) {
  const demandes = [];
  lignes
    . filter(ligne => {
      return ligne.etatSouhaite !== AUCUN;
    })
    .forEach((ligne) => {
      const devisFind = listeDevis.find((devis) => {
        return ligne.devisCommande.id === devis.id;
      });
      const avertissementFind = lignesAvertissement.find((ligneAvertissement) => {
        return ligneAvertissement.id === ligne.id;
      });
      demandes.push(genererDemande(ligne, devisFind, avertissementFind));
    });
  return demandes;
}
